import { render, staticRenderFns } from "./EbookComponent.vue?vue&type=template&id=3caee342&scoped=true&"
import script from "./EbookComponent.vue?vue&type=script&lang=ts&"
export * from "./EbookComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EbookComponent.vue?vue&type=style&index=0&id=3caee342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caee342",
  null
  
)

export default component.exports